import React from "react";
import Reveal from "../common/Reveal";
import useInView from "../../hooks/useInView";

const MILESTONES = [
  { period: "2025.01", title: "엠티에스티 법인 설립" },
  { period: "2025.03", title: "기업부설연구소 설립 · NHN Cloud 파트너사 계약" },
  { period: "2025.05", title: "MT-ALL 플랫폼 프로젝트 수주" },
  { period: "2025.09", title: "벤처기업 인증(혁신성장유형) 취득" },
  { period: "2025.11", title: "본사 사무실 확장" },
  { period: "2025.12", title: "SAP RFC 구축 · 매출 20억 달성" },
  { period: "2026.02", title: "김해지사 사무실 확보, 지역 사업 거점 구축" },
  { period: "2026.05", title: "경기도 AI 멤버십 기업 선정" },
  { period: "2026.06", title: "설비 현황 데이터 POP 구축" },
];

const HistoryTimeline = () => {
  const [lineRef, lineInView] = useInView({ threshold: 0, rootMargin: "0px 0px -15% 0px" });

  return (
    <section className="py-16">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center">
          <span className="text-sm font-semibold uppercase tracking-wide text-accent-600">
            History
          </span>
          <h2 className="mt-3 break-keep text-3xl font-bold text-primary-900 sm:text-4xl">
            회사연혁
          </h2>
        </Reveal>

        <ol ref={lineRef} className="relative mt-12 space-y-8 pl-8">
          <div className="absolute left-0 top-0 h-full w-0.5 bg-primary-100" />
          <div
            className="absolute left-0 top-0 w-0.5 origin-top bg-primary-600 transition-transform duration-[1600ms] ease-out"
            style={{
              height: "100%",
              transform: lineInView ? "scaleY(1)" : "scaleY(0)",
            }}
          />
          {MILESTONES.map((m, index) => (
            <Reveal as="li" key={m.period} delay={index * 60} direction="right" className="relative">
              <span className="absolute -left-[2.35rem] top-1 h-4 w-4 rounded-full border-4 border-white bg-primary-600 ring-1 ring-primary-100" />
              <div className="text-sm font-semibold text-accent-600">
                {m.period}
              </div>
              <div className="mt-1 break-keep text-base font-medium text-primary-900">
                {m.title}
              </div>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default HistoryTimeline;
